module.exports = __webpack_public_path__ + "static/media/icon-lock.d111b32c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-lock.svg
// module id = 225
// module chunks = 0